import React from 'react';
import PropTypes from 'prop-types';
import {InputCountNumber} from 'components/vitrade-forms/common';
import {UploadImage} from 'components/UI/Image';
import clone from 'lodash/clone';
import {removeShoppingCart} from 'actions';
import {connect} from 'react-redux';

class ShoppingItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onChange = this.onChange.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  onChange(e) {
    let product = clone(this.props);
    product.count = e.target.value;
    this.props.onChange(product);
  }

  removeItem() {
    this.props.dispatch(removeShoppingCart(this.props.id));
  }

  render() {
    return (
      <div className="item-shopping">
        <div className='item-shopping-img-wrap'>
          <UploadImage transform="crop" type="PRODUCT" width="119" height="83" image={this.props.images[this.props.images.length -1]} />
        </div>
        <p className='item-shopping-name'>{this.props.name}</p>
        <div className='item-shopping-price-wrap'>
          <p className='item-price'>{this.props.price} VNĐ</p>
          {this.props.isShowSalaPrice && <p className='item-old-price'>100.000 VNĐ</p>}
          {this.props.isShowPercentPrice && <p className='item-price-sale'>Giảm&nbsp;30%</p>}
        </div>
        <div className='item-shopping-count-wrap'>
          <InputCountNumber min={1} disabled={this.props.disabled} onChange={this.onChange} value={this.props.count}/>
          <p className='item-unit'>Đ/V:&nbsp;Cái</p>
        </div>
        <div className="item-action">
          <button type="button" className="remove-item" onClick={this.removeItem}><i className="vtd vtd-close"></i></button>
        </div>
      </div>
    );
  }
}

ShoppingItem.propTypes = {
  isShowSalaPrice: PropTypes.bool,
  isShowPercentPrice: PropTypes.bool,
  disabled: PropTypes.bool
};

ShoppingItem.defaultProps = {
  isShowSalaPrice: false,
  isShowPercentPrice: false,
  disabled: false
};

export default connect()(ShoppingItem);



// WEBPACK FOOTER //
// ./components/users/sub-view/shopping-cart/ShoppingItem.jsx